
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'

export default {
  name: 'AddToFolderTree',
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    items: {
      type: Array,
      default() {
        return []
      },
    },
    initialFolderId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      active: [this.getInitialActiveValue()],
      refTree: null,
    }
  },
  computed: {
    model() {
      const { active = [] } = this
      if (!isArrayWithLength(active)) return null
      return active?.[0] ?? null
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.model = null
        }
      },
    },
    model: {
      handler(folderId) {
        this.$emit('on-set-destination-folder-id', {
          folderId,
        })
      },
    },
  },
  methods: {
    getInitialActiveValue() {
      return !this.initialFolderId ? null : this.initialFolderId
    },
    isActive(item) {
      return item.id === this.model
    },
  },
}
